import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { IRouter } from 'i2g-ng-ui';

@Injectable()
export class ChangeEmailSuccessBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildLoginRoute(): IRouter {
    return {
      label: this._translateService.instant('ACTION.SIGN_IN_INVOICE2GO'),
      route: ['/'],
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'sign_in',
        TrackingScreenNamesEnum.change_email_success
      ),
    };
  }
}
